export const COMPANY_TYPE_QUESTION = {
    id: 'company_type',
    category: 'routing',
    question: 'Ben je voornamelijk uitlener of inlener?',
    helpText: 'Uitleners stellen arbeidskrachten ter beschikking (uitzendbureau, detachering, payroll). Inleners huren flexkrachten in.',
    appliesTo: 'both',
    options: [
        { value: 'uitlener', label: 'Uitlener (uitzendbureau / detachering / payroll)', risk: 'medium' },
        { value: 'inlener', label: 'Inlener (huurt flexkrachten in)', risk: 'medium' },
    ],
};
export const UITLENER_QUESTIONS = [
    {
        id: 'primary_activity',
        category: 'profiel',
        question: 'Wat is jouw primaire activiteit?',
        helpText: 'Selecteer de activiteit die het beste past bij jouw organisatie.',
        appliesTo: 'uitlener',
        options: [
            { value: 'uitzend', label: 'Uitzendbureau', risk: 'high' },
            { value: 'detachering', label: 'Detachering', risk: 'high' },
            { value: 'payroll', label: 'Payrolling', risk: 'high' },
            { value: 'consultancy', label: 'Consultancy/Advies', risk: 'medium' },
            { value: 'zzp', label: 'ZZP-bemiddeling', risk: 'medium' },
        ],
    },
    {
        id: 'labor_migrants_percentage',
        category: 'profiel',
        question: 'Welk percentage van jouw uitzendkrachten zijn arbeidsmigranten?',
        helpText: 'Arbeidsmigranten zijn werknemers van buiten Nederland.',
        appliesTo: 'uitlener',
        options: [
            { value: 'high', label: 'Meer dan 25%', risk: 'high' },
            { value: 'low', label: 'Minder dan 25%', risk: 'medium' },
            { value: 'none', label: 'Geen arbeidsmigranten', risk: 'low' },
        ],
    },
    {
        id: 'sna_status',
        category: 'certificering',
        question: 'Wat is de status van jouw SNA-keurmerk?',
        helpText: 'Het SNA-keurmerk (NEN 4400-1) wordt verplicht onder de WTTA.',
        appliesTo: 'uitlener',
        options: [
            { value: 'valid', label: 'Geldig SNA-certificaat', risk: 'low' },
            { value: 'pending', label: 'In aanvraag', risk: 'medium' },
            { value: 'expired', label: 'Verlopen', risk: 'high' },
            { value: 'none', label: 'Geen SNA-keurmerk', risk: 'high' },
        ],
    },
    {
        id: 'cao_compliance',
        category: 'compliance',
        question: 'Hoe pas je de juiste CAO toe?',
        helpText: 'Het correct toepassen van de inlenersbeloning is cruciaal onder WTTA.',
        appliesTo: 'uitlener',
        options: [
            { value: 'verified', label: 'Geverifieerd bij elke inlener', risk: 'low' },
            { value: 'assumed', label: 'Op basis van aanname', risk: 'medium' },
            { value: 'partial', label: 'Deels correct', risk: 'high' },
            { value: 'unclear', label: 'Onduidelijk', risk: 'high' },
        ],
    },
    {
        id: 'tax_history',
        category: 'compliance',
        question: 'Hoe is jouw historie met belasting- en premieafdracht?',
        helpText: 'Bepalend voor mogelijke vrijstelling van de waarborgsom.',
        appliesTo: 'uitlener',
        options: [
            { value: 'clean', label: 'Schone historie - geen issues', risk: 'low' },
            { value: 'minor', label: 'Kleine correcties in verleden', risk: 'medium' },
            { value: 'issues', label: 'Substantiële naheffingen of boetes', risk: 'high' },
        ],
    },
    {
        id: 'waarborgsom_capacity',
        category: 'financieel',
        question: 'Kun je een waarborgsom van € 100.000 voldoen?',
        helpText: 'WTTA vereist een waarborgsom tenzij je vrijstelling krijgt.',
        appliesTo: 'uitlener',
        options: [
            { value: 'no_problem', label: 'Geen probleem', risk: 'low' },
            { value: 'challenging', label: 'Uitdagend, maar haalbaar', risk: 'medium' },
            { value: 'financing', label: 'Alleen met externe financiering', risk: 'high' },
        ],
    },
    {
        id: 'action_plan_status',
        category: 'planning',
        question: 'Heb je al een actieplan voor WTTA-compliance?',
        helpText: 'Een concreet plan helpt bij tijdige voorbereiding.',
        appliesTo: 'uitlener',
        options: [
            { value: 'detailed', label: 'Ja, met deadlines en eigenaren', risk: 'low' },
            { value: 'basic', label: 'Ja, op hoofdlijnen', risk: 'medium' },
            { value: 'progress', label: 'Mee bezig', risk: 'medium' },
            { value: 'none', label: 'Nee', risk: 'high' },
        ],
    },
];
export const INLENER_QUESTIONS = [
    {
        id: 'flex_volume',
        category: 'profiel',
        question: 'Hoeveel flexkrachten huur je gemiddeld in?',
        helpText: 'Bepaalt jouw exposure voor ketenaansprakelijkheid.',
        appliesTo: 'inlener',
        options: [
            { value: 'high', label: 'Meer dan 50 FTE', risk: 'high' },
            { value: 'medium', label: '10-50 FTE', risk: 'medium' },
            { value: 'low', label: 'Minder dan 10 FTE', risk: 'low' },
        ],
    },
    {
        id: 'supplier_count',
        category: 'profiel',
        question: 'Via hoeveel verschillende uitleners huur je in?',
        helpText: 'Meer leveranciers betekent meer compliance-risico.',
        appliesTo: 'inlener',
        options: [
            { value: 'many', label: 'Meer dan 10', risk: 'high' },
            { value: 'several', label: '3-10', risk: 'medium' },
            { value: 'few', label: '1-2', risk: 'low' },
        ],
    },
    {
        id: 'sna_verification',
        category: 'compliance',
        question: 'Controleer je of jouw uitleners SNA-gecertificeerd zijn?',
        helpText: 'SNA-verificatie is de basis voor due diligence.',
        appliesTo: 'inlener',
        options: [
            { value: 'always', label: 'Ja, altijd bij aanvang en periodiek', risk: 'low' },
            { value: 'usually', label: 'Meestal, bij aanvang', risk: 'medium' },
            { value: 'sometimes', label: 'Soms', risk: 'high' },
            { value: 'never', label: 'Nooit', risk: 'high' },
        ],
    },
    {
        id: 'contract_wtta_clauses',
        category: 'compliance',
        question: 'Zijn WTTA-vereisten opgenomen in jouw contracten met uitleners?',
        helpText: 'Contractuele borging beschermt je bij non-compliance.',
        appliesTo: 'inlener',
        options: [
            { value: 'yes', label: 'Ja, volledig', risk: 'low' },
            { value: 'partial', label: 'Deels', risk: 'medium' },
            { value: 'no', label: 'Nee', risk: 'high' },
            { value: 'unknown', label: 'Weet ik niet', risk: 'high' },
        ],
    },
    {
        id: 'g_account_process',
        category: 'compliance',
        question: 'Heb je een proces voor G-rekening of vrijwaring?',
        helpText: 'G-rekening beperkt jouw aansprakelijkheid voor loonheffingen.',
        appliesTo: 'inlener',
        options: [
            { value: 'yes', label: 'Ja, G-rekening verplicht', risk: 'low' },
            { value: 'partial', label: 'Ja, voor sommige leveranciers', risk: 'medium' },
            { value: 'no', label: 'Nee', risk: 'high' },
        ],
    },
    {
        id: 'inlener_action_plan',
        category: 'planning',
        question: 'Heb je een plan om jouw leveranciers te toetsen op WTTA-compliance?',
        helpText: 'Proactieve toetsing beperkt jouw risico.',
        appliesTo: 'inlener',
        options: [
            { value: 'yes', label: 'Ja, met concreet tijdpad', risk: 'low' },
            { value: 'progress', label: 'Mee bezig', risk: 'medium' },
            { value: 'considering', label: 'Overwegen we', risk: 'high' },
            { value: 'no', label: 'Nee', risk: 'high' },
        ],
    },
];
export function getQuickscanQuestions(companyType) {
    return companyType === 'uitlener' ? UITLENER_QUESTIONS : INLENER_QUESTIONS;
}
export function getAllQuickscanQuestions() {
    return [COMPANY_TYPE_QUESTION, ...UITLENER_QUESTIONS, ...INLENER_QUESTIONS];
}
export function findQuestion(questionId) {
    return getAllQuickscanQuestions().find((q) => q.id === questionId);
}
//# sourceMappingURL=quickscan-questions.js.map